var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminAuditDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51898 10.6376V23.3876H13.1128V10.7876L10.7316 12.7376L8.51898 10.6376ZM12.569 22.8253H9.08148V11.9503L10.7127 13.4878L12.5689 11.969L12.569 22.8253Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6129 23.3876H19.2067V5.42529L14.6129 9.58779V23.3876ZM15.1754 9.84986L18.6441 6.69986V22.8249H15.1754V9.84986Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31281 23.3876H6.90666V9.11871L2.31281 13.431V23.3876ZM2.87531 13.6753L6.34408 10.4128V22.8251H2.87531V13.6753Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7251 3.64394L10.7312 9.64394L6.8312 6.06271L1.00006 11.4439L2.20006 12.6626L6.8312 8.38763L10.7124 11.9689L18.9624 4.84386L20.7437 6.56886L21.8874 1L15.9436 1.88123L17.7251 3.64394ZM20.3876 5.46271L18.9626 4.09394L10.7126 11.2189L6.81256 7.61894L2.2187 11.8752L1.8062 11.4627L6.8312 6.83153L10.7124 10.394L18.5501 3.66289L17.1251 2.27539L21.1564 1.69416L20.3876 5.46271Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAuditDashIcon);
export default __webpack_public_path__ + "static/media/admin-audit-dash-icon.6241507d0b8a41e9275d29275a6c2627.svg";
export { ForwardRef as ReactComponent };